import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Icon from '../AppIcon';

const Footer = () => {
  const [isMobile, setIsMobile] = useState(false);
  const currentYear = new Date()?.getFullYear();
  const lastUpdated = new Date()?.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });

  // Detect mobile viewport
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const footerSections = [
    {
      title: 'Navigation',
      links: [
        { label: 'Main Dashboard', path: '/main-visualization-dashboard' },
        { label: 'Historical Trends', path: '/historical-trend-overlay' },
        ...(isMobile ? [{ label: 'Mobile View', path: '/mobile-responsive-view' }] : [])
      ]
    },
    {
      title: 'Resources',
      links: [
        { label: 'Methodology', path: '#methodology' },
        { label: 'Data Sources', path: '#sources' },
        { label: 'API Documentation', path: '#api' }
      ]
    },
    {
      title: 'Support',
      links: [
        { label: 'Help Center', path: '#help' },
        { label: 'Contact Us', path: '#contact' },
        { label: 'Privacy Policy', path: '#privacy' }
      ]
    }
  ];

  const socialLinks = [
    { name: 'Twitter', icon: 'Twitter', url: '#twitter' },
    { name: 'GitHub', icon: 'Github', url: '#github' },
    { name: 'LinkedIn', icon: 'Linkedin', url: '#linkedin' }
  ];

  return (
    <footer className="bg-card border-t border-border mt-auto">
      <div className="container mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-3 mb-4">
              <div className="flex items-center justify-center w-10 h-10 rounded bg-primary/10">
                <Icon name="PieChart" size={24} color="var(--color-primary)" />
              </div>
              <span className="text-lg font-semibold font-heading text-foreground">
                StablecoinM2Tracker
              </span>
            </div>
            <p className="text-sm text-muted-foreground mb-4">
              Tracking the single most important macro stat for the stablecoin industry.
            </p>
            <div className="flex items-center gap-3">
              {socialLinks?.map((social) => (
                <a
                  key={social?.name}
                  href={social?.url}
                  className="flex items-center justify-center w-9 h-9 rounded transition-colors duration-300 hover:bg-muted"
                  aria-label={social?.name}
                >
                  <Icon name={social?.icon} size={18} color="var(--color-muted-foreground)" />
                </a>
              ))}
            </div>
          </div>

          {footerSections?.map((section) => (
            <div key={section?.title}>
              <h3 className="text-sm font-semibold font-heading text-foreground mb-4">
                {section?.title}
              </h3>
              <ul className="space-y-2">
                {section?.links?.map((link) => (
                  <li key={link?.label}>
                    <Link
                      to={link?.path}
                      className="text-sm text-muted-foreground transition-colors duration-300 hover:text-primary"
                    >
                      {link?.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="pt-8 border-t border-border">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="flex items-center gap-2 text-sm text-muted-foreground">
              <Icon name="Shield" size={16} color="var(--color-muted-foreground)" />
              <span>Data last updated: {lastUpdated}</span>
            </div>
            <p className="text-sm text-muted-foreground">
              © {currentYear} StablecoinM2Tracker. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;